<h2>{{ 'REGISTER-SUCCESS.checkYourInbox' | translate }}</h2>
<p>{{ 'REGISTER-SUCCESS.linkSent' | translate }}</p>
<div class="success">
  <img src="assets/img/check-inbox.svg" alt="{{ 'COMMON.back' | translate }}" />
  <div class="back">
    <app-button
      label="{{ 'COMMON.back' | translate }}"
      [fullWidth]="true"
      buttonStyle="outlined"
    />
  </div>
</div>
